import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'SIGN_ELEC',
  title: 'Come firmo elettronicamente un documento?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Fare clic su «Firmare» a destra del documento in questione'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_SIGN_ELEC/IT_SIGN_ELEC_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Viene visualizzata l\'anteprima del documento da firmare'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Accetta il documento selezionando la casella «Ho letto e accetto il documento sopra»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_SIGN_ELEC/IT_SIGN_ELEC_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Inserisci il codice univoco ricevuto tramite SMS.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '(!) il codice viene inviato automaticamente sul cellulare del firmatario inserito all\'iscrizione'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_SIGN_ELEC/IT_SIGN_ELEC_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Spuntare le CGU, le CSU e la PPDP'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_SIGN_ELEC/IT_SIGN_ELEC_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '6.',
    value: 'La prego, firmi qui!'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_SIGN_ELEC/IT_SIGN_ELEC_5.png`
  }]
};
